import { render, staticRenderFns } from "./CPageBlogIndexStandard.vue?vue&type=template&id=5c94d108&"
import script from "./CPageBlogIndexStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageBlogIndexStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports